import axios from "axios";

/**
 * Asks the server which cost alert cancelling these trips now would show
 * (CU-86cbawn2a), so the flow can show it in place of the usual confirmation.
 * Several ids share one modal, so the server returns the most severe alert.
 *
 * A failed check resolves to null: the cancel then goes ahead as usual, and a
 * cancellation that did need the alert is refused with a 409 that carries it.
 *
 * @param {Array<number>} tripIds the trips about to be cancelled
 * @returns {Promise<string|null>} 'late', 'post_cutoff' or null
 */
export const fetchCancellationAlert = (tripIds) =>
  axios
    .get("/trips/cancellation_alert", {
      params: { trip_ids: tripIds },
      headers: { Accept: "application/json" },
    })
    .then((response) => response.data.cost_alert || null)
    .catch(() => null);

/**
 * The alert a refused cancellation asks for. The server refuses with a 409 when
 * the alert was not acknowledged, or escalated while the modal was open.
 *
 * @param {Error} error the failed request's error
 * @returns {string|null} the alert to show, or null when the failure is something else
 */
export const costAlertFromError = (error) =>
  error?.response?.status === 409 ? error.response.data?.cost_alert || null : null;
